import { render, staticRenderFns } from "./NoAlgoliaHits.vue?vue&type=template&id=5413d45a&scoped=true&"
import script from "./NoAlgoliaHits.vue?vue&type=script&lang=ts&"
export * from "./NoAlgoliaHits.vue?vue&type=script&lang=ts&"
import style0 from "./NoAlgoliaHits.vue?vue&type=style&index=0&id=5413d45a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5413d45a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5413d45a', component.options)
    } else {
      api.reload('5413d45a', component.options)
    }
    module.hot.accept("./NoAlgoliaHits.vue?vue&type=template&id=5413d45a&scoped=true&", function () {
      api.rerender('5413d45a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/search/NoAlgoliaHits.vue"
export default component.exports